import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { APEX_CHARTS_TYPES, CHART_LABEL_FONT_STYLE, CHART_Y_AXIS_OFFSET } from '@src/util/constants'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import './exercise-score.sass'

@Component
export class ExerciseScore extends Vue {

  @Prop({ required: true })
  scores: [number, number][]

  @Prop({ required: false, default: '' })
  emptyMessage: ''

  chartOptions: any

  chartSeries: any[]

  firstRender: any = false

  constructor () {
    super()
  }

  mounted () {
    window.addEventListener('resize', this.updateComponent)
    window.addEventListener('orientationchange', this.updateComponent)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.updateComponent)
    window.removeEventListener('orientationchange', this.updateComponent)
    this.firstRender = false
  }

  updateComponent () {
    this.$forceUpdate()
  }

  getChartConfiguration () {
    const series = [{
      data: this.scores || /* istanbul ignore next: render only builds the chart with scores */ [],
      type: this.scores.length === 1 ? APEX_CHARTS_TYPES.SCATTER : undefined
    }]

    let categories = this.scores.map((score) => score[0])
    const xMaxValue = Math.max(...categories)
    let chartType = this.scores.length === 1 ? APEX_CHARTS_TYPES.SCATTER : APEX_CHARTS_TYPES.AREA

    const options = {
      chart: {
        type: chartType,
        height: 130,
        width: '100%',
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
        animations: {
          enabled: true
        },
        events: {
          mounted: (chart) => {
            if (!this.firstRender) {
              this.firstRender = true
              chart.updateOptions({
                chart: {
                  width: '100%',
                  animations: {
                    enabled: false
                  }
                }
              }, false, false, false)
            }
          }
        }
      },
      grid: {
        padding: {
          left: 50
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 1.5,
        curve: 'smooth'
      },
      legend: {
        show: false
      },
      markers: {
        size: 0
      },
      tooltip: {
        onDatasetHover: {
          highlightDataSeries: true
        },
        shared: false,
        marker: {
          show: true
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return '<div class="chart-tooltip rpe-tooltip">' +
             series[seriesIndex][dataPointIndex] +
            '</div>'
        }
      },
      yaxis: {
        opposite: true,
        labels: {
          ...CHART_LABEL_FONT_STYLE.style,
          fontSize: '0.875rem',
          formatter: (val) => Math.abs(val.toFixed(0))
        },
        min: 0 - CHART_Y_AXIS_OFFSET,
        max: 100 + CHART_Y_AXIS_OFFSET,
        tickAmount: undefined
      },
      xaxis: {
        type: 'category',
        categories,
        tooltip: {
          enabled: false
        },
        tickAmount: 4,
        max: xMaxValue,
        labels: {
          style: {
            ...CHART_LABEL_FONT_STYLE.style,
            fontSize: '0.875rem'
          }
        }
      }
    }

    if (chartType === APEX_CHARTS_TYPES.SCATTER) {
      return {
        series,
        options: {
          ...options,
          markers: {
            size: 7,
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            shape: 'circle'
          }
        }
      }
    }

    return { series, options }
  }

  render (h: CreateElement) {
    if (this.scores.length === 0) {
      return <ErrorScreen icon='brand/empty-graph' message={this.emptyMessage} />
    }
    const { series, options } = this.getChartConfiguration()

    return <div class='exercise-score'>
      <apexchart
        id='exercise-score-chart'
        key='exercise-score-chart'
        width='100%'
        height={options.chart.height}
        options={options} series={series}
      />
    </div>
  }
}
